import { Icon } from '@gitbook/spine-icons';
import { PageSplit, PageSplitBody, PageSplitMain, PageSplitTitle } from '@gitbook/spine-react';

import { type FirebaseMFARequiredState, useAuthOperations } from '../../state';
import { MFAVerificationForm } from './MFAVerificationForm';

/**
 * Full screen modal for the user to enter a two-factor authentication code.
 */
export function MFAScreenModal(props: { mfa: FirebaseMFARequiredState; onDone?: () => void }) {
    const { mfa, onDone = () => {} } = props;

    const { applyMFACode } = useAuthOperations();

    return (
        <PageSplit>
            <PageSplitMain>
                <PageSplitBody size="small">
                    <PageSplitTitle logo={<Icon.LogoSquare size={32} />}>
                        Two-factor authentication
                    </PageSplitTitle>
                    <MFAVerificationForm
                        align="left"
                        submitCode={(code) => applyMFACode(mfa, code)}
                        onDone={onDone}
                    />
                </PageSplitBody>
            </PageSplitMain>
        </PageSplit>
    );
}
